module.exports = __webpack_public_path__ + "img/icon_performance.514a9fce.png";